import { http } from '../http';

export enum EventName {
  FLOW_START = 'flow_start',
}

export type AnalyticsEventType = {
  event_name: EventName;
  context_data: object;
};

export const postAnalyticsEvent = (
  insuranceApplicationId: string,
  payload: AnalyticsEventType
) =>
  http.post({
    url: `/api/v1/insurance_applications/${insuranceApplicationId}/analytics/events`,
    data: payload,
  });
